import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { RecordsAction, RecordsActionTypes } from '@actions/records.actions';

import { ApiFragment } from '@stylehaven/components';
import { RecordsState } from 'state';

export const recordsAdapter: EntityAdapter<ApiFragment> = createEntityAdapter<ApiFragment>({
    selectId: record => record.metadata.Internal.FragmentId
});
export const emptyState: RecordsState = { ...recordsAdapter.getInitialState(), loading: false, error: false };

export function recordsReducer(state = emptyState, action: Action): RecordsState {
    const recordsAction: RecordsAction = action as RecordsAction;
    switch (recordsAction.type) {
        case RecordsActionTypes.AddRecords:
            return recordsAdapter.upsertMany(recordsAction.records, state);
        case RecordsActionTypes.AddRecord:
            return recordsAdapter.upsertOne(recordsAction.record, state);
        case RecordsActionTypes.RecordsLoading:
            return { ...state, loading: recordsAction.loading };
        case RecordsActionTypes.RecordsError:
            return { ...state, error: recordsAction.error };
        default:
            return state;
    }
}
